/** @file bulkHeadline: the first line of the bulk-upload report: `12 filled, 2 skipped:`. */
import type { BulkOutcome } from './artTypes';

/** `N filled`, plus `, M skipped:` when something was skipped (the colon introduces the list). */
export function bulkHeadline(outcome: BulkOutcome): string {
  const filled = `${String(outcome.filled.length)} filled`;
  return outcome.skipped.length === 0 ? filled : `${filled}, ${String(outcome.skipped.length)} skipped:`;
}
